export const FORM_QUERY_OPTIONS = {
  structuralSharing: false,
  throwOnError: false,
  refetchOnMount: true,
  staleTime: Infinity,
  gcTime: Infinity,
};

export const EMPTY_STRING_MAGIC_KEYWORD = "__empty_string__";
